import styled from 'styled-components';

export const ImpactedFieldsBox = styled.div`
  padding: 16px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  clip-path: polygon(0 0, 100% 0, 100% 200%, 0 200%);

  .regional-risk-legend-status-bar {
    height: 10px;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    margin-top: 8px;

    div {
      height: 100%;
    }

    div:first-child {
      border-radius: 8px 0px 0px 8px;
    }

    div:last-child {
      border-radius: 0px 8px 8px 0px;
    }
  }

  .list-risks {
    display: grid;
    grid-template-columns: auto auto auto auto;
    width: 100%;
    align-items: flex-end;
    margin-top: 16px;

    @media (max-width: 768px) {
      gap: 12px 8px;
    }

    div {
      flex: 1;
      flex-direction: row;

      span {
        display: flex;
      }

      span:nth-child(2) {
        font-weight: 400;
        line-height: 20px;
        letter-spacing: -0.0075em;
      }
    }
  }
`;
